
  import {defineComponent} from "vue";

  export default defineComponent({
    name: "recent-search-word-component",
    emits: [
        'click-recent-search-word',
        'delete-recent-search-word',
    ],
    props: [
        'recentSearchWordList'
    ],
    methods: {
    }
  });
